<template>
    <ion-app>
        <router-view :key="$route.fullPath" />
        <Toast :show="$toastState.show" :title="$toastState.title" :message="$toastState.message" position="top" :successful="$toastState.successful" @toast-close="$closeToast()"></Toast>
    </ion-app>
</template>

<script lang="ts">
import { IonApp, } from '@ionic/vue'
import { defineComponent } from 'vue'
import Toast from './views/Shared/Toast.vue';

export default defineComponent({
    name: 'App',
    components: {
        IonApp, Toast
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                document.title = to.meta.title || 'GT Independence';
            }
        },
    }
})
</script>
